import { Box } from "@mui/material";
import { CommonStyle, ControlledTable, Filter2 } from "Components";
import { RouteUrls } from "Constant/RouteUrls";
import { TableLayout } from "Layouts";
import { FC, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateFilter2Payload } from "Utils/common";
import { actionArr, TableCol } from "./Data";
import { Filter2DataProps } from "DataTypes/Common";
import PatientApi from "Service/Patient.api";
import Formate from "./Formate";
import { FilterArr } from "./Data";
import { GlobalType } from "DataTypes/Services/Patient.type";
import { ScreenInitialStateType, UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import CommonFormatter from "Utils/Common.Formatter";
import UI from "Constant/UI";
import { useDispatch } from "react-redux";
import { setPageLimit } from "Redux/Screen/Action";

const AllPatients: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const { listPagination }: ScreenInitialStateType = useSelector(
    (state: any) => state?.screen
  );
  const reduxLimit = (listPagination || []).find(
    el => el.id == "all-patients"
  )?.limit || 10;
  const [pageData, setPageData] = useState({
    ...UI.pageData,
    limit: reduxLimit
  });
  const [rows, setRows] = useState<GlobalType[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filterHeight, setFilterHeight] = useState<number>(0);
  const [filterData, setFilterData] = useState<Filter2DataProps[]>(
    JSON.parse(JSON.stringify(FilterArr()))
  );
  const tableHeight = `calc(99% - ${filterHeight}px)`;

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "all-patients",
      label: "All Patients",
      path: `/${RouteUrls.hs}/${RouteUrls.allPatients}`,
      level: 1,
      link: RouteUrls.allPatients,
      navType: "patient",
    });
  }, []);

  useEffect(() => {
    handleSetData(1, pageData.limit);
  }, [location.state, filterData]);

  const handleSetData: (
    currentPage: number,
    currentLimit: number
  ) => void = async (currentPage: number, currentLimit: number) => {
    setLoading(true);
    const payload = {
      data: {
        keyword: location?.state?.keyword,
        ...CreateFilter2Payload(filterData),
      },
      limit: currentLimit,
      offset: (currentPage - 1) * currentLimit,
    };
    const res = await PatientApi.GlobalPatientSearch(payload);
    let newPageData = { ...UI.pageData }
    let newRows: GlobalType[] = [];
    if (res?.success) {
      newRows = Formate.GlobalList(res?.data);
      newPageData = res.criterion
    }
    setRows(newRows);
    setPageData(newPageData)
    dispatch(setPageLimit({
      id: "all-patients",
      limit: newPageData.limit
    }));
    setLoading(false);
  };

  const handlePatientDetails: (data: GlobalType) => void = (data) => {
    navigate(`../${RouteUrls.patient}/${data.patientId}/${RouteUrls.details}`);
  };

  const handleChart: (data: GlobalType) => void = (data) => {
    navigate(
      `../${RouteUrls.patient}/${data.patientId}/${RouteUrls.clinicalSummary}`
    );
  };

  const handleTask: (data: GlobalType) => void = (data) => {
    navigate(
      `../${RouteUrls.patient}/${data.patientId}` +
      `/${RouteUrls.task}/${RouteUrls.add}`
    );
  };

  const handleAddTimeLog: (data: GlobalType) => void = (data) => {
    navigate(
      `../${RouteUrls.patient}/${data.patientId}/${RouteUrls.addonTime}`
    );
  };

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => TableCol}
      tableRow={rows}
      tableAction={(data) =>
        actionArr(
          () => handleChart(data),
          () => handlePatientDetails(data),
          () => handleTask(data),
          () => handleAddTimeLog(data),
          data,
          myInfo.roleId
        )
      }
      searchText={searchText}
    />
  );

  return (
    <Box
      height="91%"
      sx={{ ...CommonStyle.sxWhiteBox, px: 2, overflow: "auto" }}
    >
      <Filter2
        filterDataArr={filterData}
        handleFilterClick={(data) => setFilterData(data)}
        changeSearchText={(val) => setSearchText(val)}
        setFilterHeight={(val) => setFilterHeight(val)}
      />
      <TableLayout
        tblBody={TblBodyJSX}
        tblHead={ControlledTable.TblHead(TableCol)}
        height={tableHeight}
        loading={loading}
        Pagination={
          <ControlledTable.Pagination
            mainPage={pageData.page}
            limit={pageData.limit}
            total={pageData.total}
            handleClick={handleSetData}
            tableStyle={true}
          />
        }
      />
    </Box>
  );
};
export default AllPatients;
